<template>
    <div :class="['m-top-bar', {'lighter': lighter}, {'is-fixed': isFixed}]">
        <div class="wrapper">
            <i v-if="!hideBackBtn" class="icon pos-left icon-left-arrow" @click="handleBackClick"></i>
            <div class="title-con">
                <span :class="`title ${hashTitleRoute ? 'is-link' : ''}`" @click="handleTitleClick">{{ title | translate | normalize }}</span>
                <span v-if="subTitle" class="sub-title">{{ subTitle | translate | normalize }}</span>
            </div>
            <div v-if="hasIconRight" class="right-con">
                <slot name="icon-right-slot" :propData="propData"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import {checkNull, handleBackBtn} from '@/helpers'

    export default {
        name: 'm-top-bar',
        data() {
            return {

            }
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            titleRoute: {
                type: Object,
                default: () => {
                    {}
                }
            },
            backFallbackRoute: {
                type: Object,
                default: () => {
                    {}
                }
            },
            subTitle: {
                type: String,
                default: ''
            },
            lighter: {
                type: Boolean,
                default: false
            },
            isFixed: {
                type: Boolean,
                default: false
            },
            hideBackBtn: {
                type: Boolean,
                default: false
            },
            hasIconRight: {
                type: Boolean,
                default: false
            },
            propData: {
                type: Object,
                default: null
            }
        },
        methods: {
            handleBackClick() {
                handleBackBtn(this.$router, this.routeFrom, this.backFallbackRoute)
            }, 
            handleTitleClick() {
                console.log(this.titleRoute)
                if(checkNull( this.titleRoute )) this.$router.push(this.titleRoute)
            },
        },
        computed: {
            routeFrom() {
                return this.$store.getters['pub/routeFrom']
            },
            hashTitleRoute() {
                return checkNull( this.titleRoute )
            }
        },
        mounted() {

        }
    }
</script>

<style lang="scss">
.m-top-bar {
    background: #eeeff4;
    min-height: 70px;
    max-height: 70px;
    position: relative;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 2px 2px 2px #ddd;
    &.lighter {
        background: #fff;
    }
    &.is-fixed {
        width: 100%;
        position: fixed;
    }
    .wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .title-con {
            display: flex;
            flex-direction: column;
            span {
                text-transform: uppercase;
                white-space: nowrap;
                overflow: hidden!important;
                text-overflow: ellipsis;
                max-width: 80vw;
                font-size: 21px;
                text-align: center;
                &.sub-title {
                    color: #a3acb8;
                    font-size: 14px;
                    text-transform: capitalize;
                }
                &.is-link {
                    cursor: pointer;
                }
            }
        }
        i.icon {
            position: absolute;
            padding: 0 10px;
            transform: translate3d(0,-50%,0);
            cursor: pointer;
            &.pos-left {
                left: 0;
                top: 50%;
            }
            &.pos-right {
                right: 0;
                top: 50%;
            }
        }
    }
}
</style>
